const breakpoints = {
  /*
    Otto Grid breakpoints
  */
  xSmall: 320,
  small: 520,
  medium: 736,
  large: 1088,
  xLarge: 1120,

  /*
    Breakpoint values from react-spa/src/styles.tsx
  */
  xxLarge: 1200,
  xxxLarge: 1521,
}

export const theme = {
  devices: {
    tinyMobile: `(max-width: ${breakpoints.xSmall - 1}px)`,
    mobile: `(min-width: ${breakpoints.xSmall}px)`,
    tablet: `(min-width: ${breakpoints.medium}px) `,
    desktop: `(min-width: ${breakpoints.xxLarge}px) `,
    desktopWide: `(min-width: ${breakpoints.xxxLarge}px) `,
  },
}
